export default "/images/align-justify.svg?77cb95c962143ab9ab7318b51bdafedd";